module.exports = __webpack_public_path__ + "media/images/lb/640-8c66338999b5d91e0d8a3f9bc821fc1c.svg";